import {
  createPublicClient,
  createWalletClient,
  custom,
  fallback,
  http,
  type Address,
  type EIP1193Provider,
  type PublicClient,
  type WalletClient,
} from "viem";
import { appChain } from "./chain";

export const getInjectedProvider = (): EIP1193Provider => {
  const walletProvider = window.wallet?.provider;
  if (walletProvider?.request) {
    return walletProvider;
  }

  const provider = window.provider;
  if (provider?.request) {
    return provider;
  }

  throw new Error("No wallet provider available");
};

export const getWalletAccount = (account?: string): Address => {
  if (account) {
    return account as Address;
  }

  const fromWallet = window.wallet?.accounts?.[0]?.address;
  if (fromWallet) {
    return fromWallet as Address;
  }

  throw new Error("No wallet account available");
};

let publicClient: PublicClient | null = null;

export const getPublicClient = (): PublicClient => {
  if (!publicClient) {
    publicClient = createPublicClient({
      chain: appChain,
      transport: fallback(
        appChain.rpcUrls.default.http.map((url) => http(url))
      ),
    });
  }

  return publicClient;
};

export const getWalletClient = (account?: string): WalletClient => {
  return createWalletClient({
    account: getWalletAccount(account),
    chain: appChain,
    transport: custom(getInjectedProvider()),
  });
};

/** Public client backed by the connected wallet, so waits match the node that will simulate the next tx. */
export const getWalletPublicClient = (): PublicClient => {
  try {
    return createPublicClient({
      chain: appChain,
      transport: custom(getInjectedProvider()),
    });
  } catch {
    return getPublicClient();
  }
};
